import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { ApiError } from '@/api/client';
import { fetchMalleTips, type MalleTipsResponse } from '@/api/tips';
import { tripKeys } from '@/api/queryKeys';

/**
 * Liest die merged Tipps-Liste (Custom + KI). Verwendet im Trip-Hub für den
 * Rotating-Banner. Cache 10 min — Tipps ändern sich selten, und der
 * Backend-Cache hält sie eh 30 Tage.
 */
export function useMalleTips(slug: string) {
  return useQuery({
    queryKey: tripKeys.tips(slug),
    queryFn: ({ signal }) => fetchMalleTips(slug, { signal }),
    staleTime: 10 * 60_000,
    enabled: !!slug,
  });
}

/**
 * Forciert eine KI-Regeneration via ?force=1 — bypassed den 30d-KV-Cache.
 * Nutzt der Admin im MalleTips-Editor. Schreibt die Response gleich in den
 * Tips-Cache (damit der Rotator auf der PlanPage sofort die frischen Tipps
 * sieht, ohne erneuten Fetch).
 */
export function useRegenerateMalleTips(slug: string) {
  const qc = useQueryClient();
  return useMutation<MalleTipsResponse, ApiError, void>({
    mutationFn: () => fetchMalleTips(slug, { force: true }),
    onSuccess: (data) => {
      qc.setQueryData<MalleTipsResponse>(tripKeys.tips(slug), data);
    },
  });
}
